import React, { useContext } from "react";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import { Link, useParams } from "react-router-dom";
import { apiValue3 } from "../Data/AllData";
import { CartProvider, useCart } from "react-use-cart";


function Page3(){
  const { addItem } = useCart();
  const { id } = useParams();
  const api3 = useContext(apiValue3);

  return(
    <div>
      {api3.map((element3) => {
        return element3.id == id ? (
          <section className="bg-light" key={element3.id}>
            <div className="container pb-5">
              <div className="row">
                <div className="col-lg-5 mt-5">
                  <div className="card mb-3">
                    <img
                      className="card-img img-fluid"
                      src={element3.images[0]}
                      alt={element3.title}
                      id="product-detail"
                    />
                  </div>
                </div>

                <div className="col-lg-7 mt-5">
                  <div className="card">
                    <div className="card-body">
                      <h1 className="h2 text-success mb-3">{element3.title}</h1>
                      <p className="h3 ">
                        <b>${element3.price}</b>
                      </p>
                      <p>
                        <span className="list-inline-item text-dark">
                          <b>Id :</b> {element3.id} 
                        </span>
                      </p>
                      <p>
                        <span className="list-inline-item text-dark">
                          <b>Rating :</b> {element3.rating} of 5
                        </span>
                      </p>
                      <ul className="list-inline">
                        <li className="list-inline-item">
                          <h6>Brand :</h6>
                        </li>
                        <li className="list-inline-item">
                          <p>{element3.brand}</p>
                        </li>
                      </ul>
                      <h6>Description :</h6>
                      <p>{element3.description}</p>
                      <ul className="list-inline">
                        <li className="list-inline-item">
                          <h6>Stock :</h6>
                        </li>
                        <li className="list-inline-item">
                          <p>{element3.stock}</p>
                        </li>
                      </ul>

                      <div className="row pb-3">
                        <div className="col d-grid">
                          <Link
                            to="/laptop"
                            className="btn btn-secondary btn-lg"
                          >
                            Back to shopping
                          </Link>
                        </div>
                        <div className="col d-grid">
                          <button
                            onClick={() => addItem(element3)}
                            className="btn btn-success btn-lg"
                          >
                            Add To Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : null;
      })}
    </div>
  );

};


function SingleLaptop() {

  return (
    <CartProvider>
      <Navbar />
      <br/>
      <br/>
      <br/>
      <br/>
      <Page3/>
      <Footer />
    </CartProvider>
  );
};

export default SingleLaptop;
